import {
    CHECKOUT_FRAUD_BLOCK,
    CHECKOUT_PAYMENT_DECLINED,
    PHONE_DENIED,
    PHONE_TOO_MANY_ATTEMPTS,
} from '@/src/common/constants'
import sendFullStoryEvent from '@/src/common/utilities/fullstory/sendFullStoryEvent'
import determineStoredPhoneInfo from '@/src/common/utilities/fullstory/determineStoredPhoneInfo'
import { User } from 'firebase/auth'
import { currencyFormatter } from '@/src/common/utilities/currencyFormatter'

export function sendTooManyPhoneAttemptsFSEvent(
    user: User | null,
    currentPhone: string,
    reason: string
) {
    const { storedExpiration, storedPhones } = determineStoredPhoneInfo()

    sendFullStoryEvent(PHONE_TOO_MANY_ATTEMPTS, {
        user_id: user?.uid,
        stored_user_phone: user?.phoneNumber,
        attempted_phone_numbers: storedPhones,
        current_phone_input: currentPhone,
        attempt_expiration: storedExpiration,
        attempt_timestamp: new Date().toISOString(),
        page: '/checkout',
        ui_context: 'Checkout Form',
        verification_method: 'SMS',
        verification_status: reason,
    })
}

export function sendCheckoutBlockedOrDeclinedFSEvent(
    event: typeof CHECKOUT_FRAUD_BLOCK | typeof CHECKOUT_PAYMENT_DECLINED,
    user: User | null,
    stripeError: {
        code?: string
        decline_code?: string
        message?: string
        payment_email?: string | null
        payment_phone?: string | null
    },
    amount: number = 0
) {
    const paymentStatus: 'blocked' | 'declined' =
        event === CHECKOUT_PAYMENT_DECLINED ? 'declined' : 'blocked'

    sendFullStoryEvent(event, {
        user_id: user?.uid,
        user_contact: user?.phoneNumber ?? user?.email,
        attempt_timestamp: new Date().toISOString(),
        page: '/checkout',
        ui_context: 'Checkout Form',
        payment_status: paymentStatus,
        stripe_error_info: stripeError,
        cart_amount: currencyFormatter(amount),
    })
}

export function sendPhoneDeniedFSEvent(
    user: User | null,
    currentPhone: string
) {
    sendFullStoryEvent(PHONE_DENIED, {
        user_id: user?.uid,
        stored_user_phone: user?.phoneNumber,
        phone_number_denied: currentPhone,
        attempt_timestamp: new Date().toISOString(),
        page: '/checkout',
        ui_context: 'Checkout Form',
        verification_method: 'SMS',
        verification_status: 'denied',
    })
}
